import type { IntlShape } from 'react-intl';
import { messages } from '../../i18n/index';
import { defaultLocale, supportedLocales, type AppLocale } from '../../i18n/supported-locales';

function normalizeLocale(locale: string): AppLocale {
  return (supportedLocales as readonly string[]).includes(locale)
    ? (locale as AppLocale)
    : defaultLocale;
}

function applyTemplate(template: string, values: Record<string, string>): string {
  let out = template;
  for (const [k, v] of Object.entries(values)) {
    out = out.split(`{${k}}`).join(v);
  }
  return out;
}

const DESCRIPTOR = {
  id: 'marketHeader.backgroundImageAlt',
  defaultMessage: 'Background photograph of {location}',
  description: 'Alt text for the location hero background image on job search; {location} is the translated place name',
} as const;

/**
 * SSR / static SRP: localized alt for location market header background `img`.
 */
export function formatLocationBackgroundImageAltSync(locale: string, translatedLocation: string): string {
  const loc = normalizeLocale(locale);
  const bundle = messages[loc];
  const t = bundle[DESCRIPTOR.id] ?? messages.en[DESCRIPTOR.id] ?? DESCRIPTOR.defaultMessage;
  const place = translatedLocation.trim() || 'Finland';
  return applyTemplate(t, { location: place });
}

/** Client `MarketHeader` (react-intl). */
export function formatLocationBackgroundImageAltFromIntl(intl: IntlShape, translatedLocation: string): string {
  const place = translatedLocation.trim() || 'Finland';
  return intl.formatMessage(DESCRIPTOR, { location: place });
}
